import {ClipboardStateType} from 'module/Clipboard/reducer/ClipboardReducer'

export const selClipboardMap = (state: ClipboardStateType) => state.Clipboard